import {Injectable} from '@angular/core';
import {DeploymentService} from "../../services/deployment.service";
import {NotificationService} from "../../services/notification.service";
import {map, Observable} from "rxjs";
import {ConfirmationDialogComponent} from "./gateway-network-config/confirmation-dialog/confirmation-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {ConfirmationDialogGenericComponent} from "./confirmation-dialog-generic/confirmation-dialog-generic.component";

@Injectable({
  providedIn: 'root'
})
export class GatewayConfigPermissionsServiceService {

  constructor(
    private deploymentService: DeploymentService,
    private notificationService: NotificationService,
    private dialog: MatDialog,

  ) {
  }


  hasEditGatewayConfigurationPermissionAndNotify(serial: string): Observable<boolean> {
    this.notifyIfNoPermission(serial);

    return this.deploymentService.hasEditGatewayConfigurationPermission(serial).pipe(map(res => res.hasEditGatewayConfigurationPermission))
  }

    notifyIfNoPermission(serial: string) {
    this.deploymentService.isGatewayOsVersionSupported(serial).subscribe(response => {
      console.log("response:", response)
      if (!response.isOsVersionSupported) {
        const dialogRef = this.dialog.open(ConfirmationDialogGenericComponent, {
          panelClass: 'dialog-container-custom',
          disableClose: true,
          data: {
            text: "Please update the operating system of the gateway, before doing any configuration changes",
          },
          width: '792px',
          height: '330px',
          autoFocus: false,
        });
      }
    })
  }
}
